// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShortStoriesBanner_bannerContainer__4Cyrt {
    position: relative;
    width: 100%;
    height: 100vh;
    max-height: 800px;
    overflow: hidden;
  }
  
  .ShortStoriesBanner_bannerBackground__puqan {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center top;
    transition: opacity 0.8s ease;
  }
  
  .ShortStoriesBanner_bannerGradient__B3bp0 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 
    linear-gradient(
      to top,
      rgba(26, 26, 26, 0.6) 0%,
      rgba(26, 26, 26, 0) 50%
    ),
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.4) 55%,
      rgba(0, 0, 0, 0) 80%,
      #1a1a1a 100%
    );
  }
  
  .ShortStoriesBanner_bannerContent__6y840 {
    position: absolute;
    bottom: 20%;
    left: 5%;
    width: 50%;
    color: white;
    z-index: 2;
  }
  
  .ShortStoriesBanner_storyTitle__WrRyA {
    font-size: 3rem;
    font-weight: 800;
    margin-bottom: 1rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  .ShortStoriesBanner_storyMeta__SqD1l {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  
  .ShortStoriesBanner_genreBadge__WjShZ {
    background-color: rgba(255, 255, 255, 0.2);
    padding: 0.25rem 0.75rem;
    border-radius: 4px;
    font-size: 0.9rem;
    font-weight: 500;
  }
  
  .ShortStoriesBanner_duration__fOn5w, .ShortStoriesBanner_language__bKuS4 {
    font-size: 0.9rem;
    opacity: 0.8;
  }
  
  .ShortStoriesBanner_storyDescription__dFyAV {
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
  }
  
  .ShortStoriesBanner_actionButtons__a9\\+b\\+ {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }
  
  .ShortStoriesBanner_playButton__G3Nu6, .ShortStoriesBanner_infoButton__mtTh6 {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
  }
  
  .ShortStoriesBanner_playButton__G3Nu6 {
    background-color: #e50914; /* Netflix red */
    color: white;
  }
  
  .ShortStoriesBanner_playButton__G3Nu6:hover {
    background-color: #f40612;
    transform: scale(1.05);
  }
  
  .ShortStoriesBanner_infoButton__mtTh6 {
    background-color: rgba(109, 109, 110, 0.7);
    color: white;
  }
  
  .ShortStoriesBanner_infoButton__mtTh6:hover {
    background-color: rgba(109, 109, 110, 0.9);
  }
  
  .ShortStoriesBanner_storyIndicators__wq0Np {
    position: absolute;
    bottom: 6%;
    right: 5%;
    display: flex;
    gap: 0.5rem;
  }
  
  .ShortStoriesBanner_indicator__KXbEK {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.3);
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .ShortStoriesBanner_indicator__KXbEK.ShortStoriesBanner_active__3-uNj {
    background-color: white;
    transform: scale(1.2);
  }
  
  .ShortStoriesBanner_loadingContainer__qe0z- {
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #111;
  }
  
  .ShortStoriesBanner_loader__WSn2n {
    width: 48px;
    height: 48px;
    border: 5px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #e50914;
    animation: ShortStoriesBanner_spin__-0eVZ 1s ease-in-out infinite;
  }
  
  @keyframes ShortStoriesBanner_spin__-0eVZ {
    to {
      transform: rotate(360deg);
    }
  }
  
  .ShortStoriesBanner_errorContainer__0ik1f {
    width: 100%;
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #111;
    color: white;
    text-align: center;
    padding: 2rem;
  }
  
  /* Responsive styles */
  @media (max-width: 1200px) {
    .ShortStoriesBanner_storyTitle__WrRyA {
      font-size: 2.5rem;
    }
    
    .ShortStoriesBanner_bannerContent__6y840 {
      width: 60%;
    }
  }
  
  @media (max-width: 992px) {
    .ShortStoriesBanner_bannerContainer__4Cyrt {
      height: 70vh;
    }
    
    .ShortStoriesBanner_storyTitle__WrRyA {
      font-size: 2.2rem;
    }
    
    .ShortStoriesBanner_bannerContent__6y840 {
      width: 70%;
    }
  }
  
  @media (max-width: 768px) {
    .ShortStoriesBanner_bannerContainer__4Cyrt {
      height: 60vh;
    }
    
    .ShortStoriesBanner_storyTitle__WrRyA {
      font-size: 1.8rem;
    }
    
    .ShortStoriesBanner_storyDescription__dFyAV {
      font-size: 1rem;
      -webkit-line-clamp: 2;
    }
    
    .ShortStoriesBanner_bannerContent__6y840 {
      width: 85%;
      bottom: 15%;
    }
    
    .ShortStoriesBanner_playButton__G3Nu6, .ShortStoriesBanner_infoButton__mtTh6 {
      padding: 0.6rem 1.2rem;
      font-size: 1rem;
    }
  }
  
  @media (max-width: 576px) {
    .ShortStoriesBanner_bannerContainer__4Cyrt {
      height: 50vh;
      min-height: 300px;
    }
    
    .ShortStoriesBanner_storyTitle__WrRyA {
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
    }
    
    .ShortStoriesBanner_storyMeta__SqD1l {
      gap: 0.5rem;
      margin-bottom: 0.5rem;
    }
    
    .ShortStoriesBanner_storyDescription__dFyAV {
      -webkit-line-clamp: 2;
      margin-bottom: 1rem;
      font-size: 0.9rem;
    }
    
    .ShortStoriesBanner_bannerContent__6y840 {
      bottom: 10%;
      width: 90%;
      left: 5%;
    }
    
    .ShortStoriesBanner_actionButtons__a9\\+b\\+ {
      gap: 0.5rem;
    }
    
    .ShortStoriesBanner_playButton__G3Nu6, .ShortStoriesBanner_infoButton__mtTh6 {
      padding: 0.5rem 1rem;
      font-size: 0.9rem;
    }
    
    .ShortStoriesBanner_storyIndicators__wq0Np {
      bottom: 5%;
      right: 5%;
    }
    
    .ShortStoriesBanner_indicator__KXbEK {
      width: 8px;
      height: 8px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/ShortStories/language/ShortStoriesBanner.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,+BAA+B;IAC/B,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;;;;;;;;;;;KAWC;EACH;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,0CAA0C;IAC1C,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB,EAAE,gBAAgB;IAC3C,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,0CAA0C;IAC1C,YAAY;EACd;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,aAAa;IACb,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,yBAAyB;IACzB,iEAAuC;EACzC;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,UAAU;IACZ;EACF;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,qBAAqB;IACvB;;IAEA;MACE,UAAU;MACV,WAAW;IACb;;IAEA;MACE,sBAAsB;MACtB,eAAe;IACjB;EACF;;EAEA;IACE;MACE,YAAY;MACZ,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,qBAAqB;IACvB;;IAEA;MACE,WAAW;MACX,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;MACrB,mBAAmB;MACnB,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,UAAU;MACV,QAAQ;IACV;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,oBAAoB;MACpB,iBAAiB;IACnB;;IAEA;MACE,UAAU;MACV,SAAS;IACX;;IAEA;MACE,UAAU;MACV,WAAW;IACb;EACF","sourcesContent":[".bannerContainer {\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    max-height: 800px;\n    overflow: hidden;\n  }\n  \n  .bannerBackground {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-position: center top;\n    transition: opacity 0.8s ease;\n  }\n  \n  .bannerGradient {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: \n    linear-gradient(\n      to top,\n      rgba(26, 26, 26, 0.6) 0%,\n      rgba(26, 26, 26, 0) 50%\n    ),\n    linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0.4) 55%,\n      rgba(0, 0, 0, 0) 80%,\n      #1a1a1a 100%\n    );\n  }\n  \n  .bannerContent {\n    position: absolute;\n    bottom: 20%;\n    left: 5%;\n    width: 50%;\n    color: white;\n    z-index: 2;\n  }\n  \n  .storyTitle {\n    font-size: 3rem;\n    font-weight: 800;\n    margin-bottom: 1rem;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n  }\n  \n  .storyMeta {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 1rem;\n  }\n  \n  .genreBadge {\n    background-color: rgba(255, 255, 255, 0.2);\n    padding: 0.25rem 0.75rem;\n    border-radius: 4px;\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n  \n  .duration, .language {\n    font-size: 0.9rem;\n    opacity: 0.8;\n  }\n  \n  .storyDescription {\n    font-size: 1.1rem;\n    margin-bottom: 1.5rem;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n  }\n  \n  .actionButtons {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n  }\n  \n  .playButton, .infoButton {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    border-radius: 4px;\n    font-size: 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: none;\n  }\n  \n  .playButton {\n    background-color: #e50914; /* Netflix red */\n    color: white;\n  }\n  \n  .playButton:hover {\n    background-color: #f40612;\n    transform: scale(1.05);\n  }\n  \n  .infoButton {\n    background-color: rgba(109, 109, 110, 0.7);\n    color: white;\n  }\n  \n  .infoButton:hover {\n    background-color: rgba(109, 109, 110, 0.9);\n  }\n  \n  .storyIndicators {\n    position: absolute;\n    bottom: 6%;\n    right: 5%;\n    display: flex;\n    gap: 0.5rem;\n  }\n  \n  .indicator {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.3);\n    border: none;\n    cursor: pointer;\n    transition: all 0.3s ease;\n  }\n  \n  .indicator.active {\n    background-color: white;\n    transform: scale(1.2);\n  }\n  \n  .loadingContainer {\n    width: 100%;\n    height: 400px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #111;\n  }\n  \n  .loader {\n    width: 48px;\n    height: 48px;\n    border: 5px solid rgba(255, 255, 255, 0.3);\n    border-radius: 50%;\n    border-top-color: #e50914;\n    animation: spin 1s ease-in-out infinite;\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .errorContainer {\n    width: 100%;\n    height: 400px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background-color: #111;\n    color: white;\n    text-align: center;\n    padding: 2rem;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 1200px) {\n    .storyTitle {\n      font-size: 2.5rem;\n    }\n    \n    .bannerContent {\n      width: 60%;\n    }\n  }\n  \n  @media (max-width: 992px) {\n    .bannerContainer {\n      height: 70vh;\n    }\n    \n    .storyTitle {\n      font-size: 2.2rem;\n    }\n    \n    .bannerContent {\n      width: 70%;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .bannerContainer {\n      height: 60vh;\n    }\n    \n    .storyTitle {\n      font-size: 1.8rem;\n    }\n    \n    .storyDescription {\n      font-size: 1rem;\n      -webkit-line-clamp: 2;\n    }\n    \n    .bannerContent {\n      width: 85%;\n      bottom: 15%;\n    }\n    \n    .playButton, .infoButton {\n      padding: 0.6rem 1.2rem;\n      font-size: 1rem;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .bannerContainer {\n      height: 50vh;\n      min-height: 300px;\n    }\n    \n    .storyTitle {\n      font-size: 1.5rem;\n      margin-bottom: 0.5rem;\n    }\n    \n    .storyMeta {\n      gap: 0.5rem;\n      margin-bottom: 0.5rem;\n    }\n    \n    .storyDescription {\n      -webkit-line-clamp: 2;\n      margin-bottom: 1rem;\n      font-size: 0.9rem;\n    }\n    \n    .bannerContent {\n      bottom: 10%;\n      width: 90%;\n      left: 5%;\n    }\n    \n    .actionButtons {\n      gap: 0.5rem;\n    }\n    \n    .playButton, .infoButton {\n      padding: 0.5rem 1rem;\n      font-size: 0.9rem;\n    }\n    \n    .storyIndicators {\n      bottom: 5%;\n      right: 5%;\n    }\n    \n    .indicator {\n      width: 8px;\n      height: 8px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerContainer": `ShortStoriesBanner_bannerContainer__4Cyrt`,
	"bannerBackground": `ShortStoriesBanner_bannerBackground__puqan`,
	"bannerGradient": `ShortStoriesBanner_bannerGradient__B3bp0`,
	"bannerContent": `ShortStoriesBanner_bannerContent__6y840`,
	"storyTitle": `ShortStoriesBanner_storyTitle__WrRyA`,
	"storyMeta": `ShortStoriesBanner_storyMeta__SqD1l`,
	"genreBadge": `ShortStoriesBanner_genreBadge__WjShZ`,
	"duration": `ShortStoriesBanner_duration__fOn5w`,
	"language": `ShortStoriesBanner_language__bKuS4`,
	"storyDescription": `ShortStoriesBanner_storyDescription__dFyAV`,
	"actionButtons": `ShortStoriesBanner_actionButtons__a9+b+`,
	"playButton": `ShortStoriesBanner_playButton__G3Nu6`,
	"infoButton": `ShortStoriesBanner_infoButton__mtTh6`,
	"storyIndicators": `ShortStoriesBanner_storyIndicators__wq0Np`,
	"indicator": `ShortStoriesBanner_indicator__KXbEK`,
	"active": `ShortStoriesBanner_active__3-uNj`,
	"loadingContainer": `ShortStoriesBanner_loadingContainer__qe0z-`,
	"loader": `ShortStoriesBanner_loader__WSn2n`,
	"spin": `ShortStoriesBanner_spin__-0eVZ`,
	"errorContainer": `ShortStoriesBanner_errorContainer__0ik1f`
};
export default ___CSS_LOADER_EXPORT___;
